import { createStore } from 'effector';
import { User } from '@nx-frontend/shared/types';

export const initialUserState: User = {
  id: 1, // readonly user
  username: 'guest',
  displayName: 'guest',
  email: '',
  registerDate: 0,
  subscribeNewsletter: false,
  service: '',
  emailConfirmed: false,
  emailDeliverySuspended: false,
};

export const $user = createStore(initialUserState);

export const $isAppSumoUser = $user.map((user) => {
  if (!user) {
    return false;
  }

  if (!user.email) {
    return false;
  }

  return user.remoteApplication === 'appsumo';
});

export const $userId = $user.map((state) => state.id);
